import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function TicketsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="tick_tags"
					label={t('DETAILS_TICKETS_FIELD_TAGS')}
					value={props.model.tick_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="tick_warning_desc"
					label={t('DETAILS_TICKETS_FIELD_WARNING')}
					value={props.model.tick_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="tick_blocked_desc"
					label={t('DETAILS_TICKETS_FIELD_BLOCKED')}
					value={props.model.tick_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
